<template>
  <el-select v-model="selectValue" :placeholder="placeholder" filterable
    :remote-method="searchWx" @change="editReceiveName" :loading="searchingWx" remote
    reserve-keyword remote-show-suffix :clearable="clearable">
    <el-option class="select_option" v-for="item in state.selectList" :key="item.remark || item.nickname"
      :label="item.remark" :value="item.remark">
      <span style="float: left;">{{ item.remark }}</span>
      <span style="float: left;color: var(--el-text-color-secondary);font-size: 13px;">
        ({{ item.nickname }})
      </span>
    </el-option>
    <el-option v-if='state.selectList.length >= 10' disabled value="more"> <span
        style="color:#E6A23C">最多展示10个微信好友，更多请输入备注/昵称搜索</span> </el-option>
  </el-select>
</template>

<script setup>
import { computed,reactive,ref } from 'vue';
import { getWxListByName, editStudentReceiveWeChatInfo } from '@/api/common.js'
import { ElNotification } from 'element-plus';
const emit = defineEmits(['update:modelValue','change','update:unionId','update:externalUserId','update:receiveWeChatName'])
const props = defineProps({
  studentCode:{
    required:true
  },
  clearable:{
    type: Boolean,
    default: true
  },
  needSave:{
    type: Boolean,
    default: true
  },
  modelValue:{
    default:''
  },
  unionId:{
    default: ''
  },
  externalUserId:{
    default:''
  },
  receiveWeChatName:{
    default:''
  },
  placeholder:{
    default: '请选择'
  }
})
const searchingWx = ref(false);
const selectValue = computed({
  get: () => props.modelValue,
  set: (v) => {
    
    emit('update:modelValue',v || '')
  }
})
let defaultModelValue = props.modelValue;
const state = reactive({
  selectList:[]
})
const searchWx = (query) => {
  //if(!query)return;
  getWxListByName({
    keyword: query
  }).then(res => {
    state.selectList = res//.map(item => item.remark || item.nickname)
  })
}
const editReceiveName = (v) => {
  let receiveWeChatName = '';
  let unionId = '';
  let externalUserId = '';
  let receiveId = ''
  state.selectList.some(item=>{
    if(item.remark == v){
      receiveWeChatName = item.nickname
      unionId = item.unionId;
      externalUserId = item.externalUserId;
      receiveId = item.externalUserId;
      return true;
    }
  })
  if(defaultModelValue == receiveWeChatName)return; // 没有变动就不保存
  
  editStudentReceiveWeChatInfo({
    unionId:v ? unionId : '',
    externalUserId: v ? externalUserId : '',
    receiveWeChatRemark: v || '',
    receiveWeChatName: receiveWeChatName,
    receiveId: receiveId,
    studentCode: props.studentCode
  }).catch(err=>{
    if(!props.needSave)return;
    ElNotification({
      title: '提示',
      message: `微信备注更新失败（${err}）`,
      type: 'error',
    })
  })
  defaultModelValue = receiveWeChatName
  
  emit('update:unionId',unionId)
  emit('update:externalUserId',externalUserId)
  emit('update:receiveWeChatName',receiveWeChatName)
  emit('change',v || '')
}
</script>

<style lang="scss" scoped></style>